import type { PlatformCardType } from '../../types/chat';

export type CardPresentation =
  | 'list'
  | 'detail'
  | 'purchase_order_detail'
  | 'document_review_detail'
  | 'match_exception_detail'
  | 'approval_decision_detail'
  | 'ap_posting_review_detail';

export const platformCardCatalog: Record<PlatformCardType, {
  presentation: CardPresentation;
  primary?: string[];
  secondary?: string[];
  status?: string[];
}> = {
  document_list: { presentation: 'list', primary: ['invoice_number', 'po_number', 'id'], secondary: ['vendor_name', 'total', 'currency'], status: ['extraction_status', 'match_status'] },
  document_detail: { presentation: 'detail' },
  document_review_detail: { presentation: 'document_review_detail' },
  review_queue: { presentation: 'list', primary: ['invoice_number', 'po_number', 'id'], secondary: ['vendor_name', 'total', 'currency', 'doc_confidence'], status: ['extraction_status', 'match_status'] },
  purchase_order_list: { presentation: 'list', primary: ['po_number', 'id'], secondary: ['vendor_name', 'total', 'currency'], status: ['extraction_status', 'match_status'] },
  purchase_order_detail: { presentation: 'purchase_order_detail' },
  document_match_detail: { presentation: 'detail' },
  match_exception_detail: { presentation: 'match_exception_detail' },
  document_flag_list: { presentation: 'list', primary: ['flag_type'], secondary: ['details'], status: ['severity', 'status'] },
  vendor_list: { presentation: 'list', primary: ['legal_name', 'id'], secondary: ['default_payment_terms'], status: ['status'] },
  vendor_detail: { presentation: 'detail' },
  approval_list: { presentation: 'list', primary: ['document_type', 'id'], secondary: ['current_step'], status: ['status'] },
  approval_queue: { presentation: 'list', primary: ['title', 'document_type', 'id'], secondary: ['action_type', 'requested_by', 'approval_progress'], status: ['status'] },
  approval_history: { presentation: 'list', primary: ['event_type', 'approver_name'], secondary: ['comments', 'corrected_by_name'], status: ['decision'] },
  approval_decision_detail: { presentation: 'approval_decision_detail' },
  approval_chain_list: { presentation: 'list', primary: ['name', 'id'], secondary: ['action_type', 'entity_type'], status: ['is_enabled'] },
  subscription_usage: { presentation: 'detail' },
  mailbox_connections: { presentation: 'list', primary: ['display_name', 'email_address', 'id'], secondary: ['provider', 'polling_interval_minutes'], status: ['status'] },
  ap_posting_detail: { presentation: 'detail' },
  ap_posting_review_detail: { presentation: 'ap_posting_review_detail' },
  erp_item_list: { presentation: 'list', primary: ['name', 'sku', 'id'], secondary: ['item_type', 'sku'], status: ['active'] },
  erp_connection_detail: { presentation: 'detail' },
  metric_list: { presentation: 'list', primary: ['label', 'key', 'id'], secondary: ['description'] },
  summary: { presentation: 'detail' },
  dashboard_widget: { presentation: 'detail' },
  form: { presentation: 'detail' },
  action_result: { presentation: 'detail' },
};
